import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useState } from 'react';

const SignInModal = ({ onClose, redirectPath }: { onClose: () => void; redirectPath?: string }) => {
    const navigate = useNavigate();

    const { fetchToken } = useAuth();
    const [isSigningIn, setIsSigningIn] = useState(false);

    const LoginPromptView = () => {
        const googleLogin = useGoogleLogin({
            onSuccess: async (credentialResponse) => {
                try {
                    setIsSigningIn(true);
                    await fetchToken(credentialResponse.access_token);
                    if (redirectPath) {
                        navigate(redirectPath);
                        handleClose();
                    } else {
                        window.location.reload();
                    }
                } catch (error) {
                    console.log('Login Failed');
                } finally {
                    setIsSigningIn(false);
                }
            },
            onError: () => {
                console.log('Login Failed');
                setIsSigningIn(false);
            },
            onNonOAuthError: () => {
                console.log('Login Failed');
                setIsSigningIn(false);
            },
        });

        const handleGoogleLogin = () => {
            setIsSigningIn(true);
            googleLogin();
        };

        return (
            <div className="mt-5">
                <div
                    className={`w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 cursor-pointer shadow-sm hover:bg-gray-50 ${isSigningIn ? 'opacity-50 pointer-events-none' : ''
                        }`}
                    onClick={handleGoogleLogin}
                >
                    <svg className="w-4 h-auto" width="46" height="47" viewBox="0 0 46 47" fill="none">
                        <path d="M46 24.0287C46 22.09 45.8533 20.68 45.5013 19.2112H23.4694V27.9356H36.4069C36.1429 30.1094 34.7347 33.37 31.5957 35.5731L31.5663 35.8669L38.5191 41.2719L38.9885 41.3306C43.4477 37.2181 46 31.1669 46 24.0287Z" fill="#4285F4" />
                        <path d="M23.4694 47C29.8061 47 35.1161 44.9144 39.0179 41.3012L31.625 35.5437C29.6301 36.9244 26.9898 37.8937 23.4987 37.8937C17.2793 37.8937 12.0281 33.7812 10.1505 28.1412L9.88649 28.1706L2.61097 33.7812L2.52296 34.0456C6.36608 41.7125 14.287 47 23.4694 47Z" fill="#34A853" />
                        <path d="M10.1212 28.1413C9.62245 26.6725 9.32908 25.1156 9.32908 23.5C9.32908 21.8844 9.62245 20.3275 10.0918 18.8588V18.5356L2.75765 12.8369L2.52296 12.9544C0.909439 16.1269 0 19.7106 0 23.5C0 27.2894 0.909439 30.8731 2.49362 34.0456L10.1212 28.1413Z" fill="#FBBC05" />
                        <path d="M23.4694 9.07688C27.8699 9.07688 30.8622 10.9863 32.5344 12.5725L39.1645 6.11C35.0867 2.32063 29.8061 0 23.4694 0C14.287 0 6.36607 5.2875 2.49362 12.9544L10.0918 18.8588C11.9987 13.1894 17.25 9.07688 23.4694 9.07688Z" fill="#EB4335" />
                    </svg>
                    Sign in with Google
                </div>
            </div>
        );
    };

    const handleClose = () => {
        if (!isSigningIn) {
            onClose();
        }
    };

    return (
        <div id="signin-modal" className="fixed inset-0 z-[80] flex items-center justify-center">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={handleClose}></div>

            <div className="bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full relative z-[90]">
                <div className="absolute top-2 end-2">
                    <button type="button"
                        className={`flex justify-center items-center size-7 text-sm font-semibold rounded-lg border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none ${isSigningIn ? 'opacity-50 pointer-events-none' : ''}`}
                        onClick={handleClose}>
                        <span className="sr-only">Close</span>
                        <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                    </button>
                </div>
                <div className="p-4 sm:p-7 text-center">

                    <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">

                        <div className="text-center">
                            <h2 className="block text-2xl font-bold text-gray-80">Sign in</h2>
                        </div>
                        <LoginPromptView />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignInModal;